import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import store from "../store/index";
import useOrder from "../hooks/useOrder";
import transferIcon from "../img/arrow-left-right.svg";

// ICONS
import previewIcon from "../img/preview.svg";
import clockIcon from "../img/clock.svg";

// COMPONENTS
import RunningKOTStatus from "../Component/RunningKOTStatus";
import TabNavigation from "../Component/TabNavigation";
import OrderMenu from "./OrderMenu";
import Loader from "../Component/Loader";
import { SUCCESS } from "../assets/constants";
import { useCloud } from "../hooks/useCloud";
import toast from "react-hot-toast";
import PartnerOrders from "../Component/PartnerOrder/Component/PartnerOrders";
const TableCard = ({ table, handleTableSelect, room }) => {
  const [tableStatus, setTableStatus] = useState("VACANT");
  const [elapsedTime, setElapsedTime] = useState("");
  const [orderAmount, setOrderAmount] = useState(0);
  const [customerName, setCustomerName] = useState("");
  const [isOrderRunning, setIsOrderRunning] = useState(false);
  const [update, setUpdate] = useState(0);

  const fetchTableStatus = async () => {
    const order = store.runningVPA[table.qrpidVPA];
    if (order) {
      const now = new Date();
      const diffMs = now - new Date(order.createdAt);
      const diffMinutes = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMinutes / 60);
      const remainingMinutes = diffMinutes % 60;
      const timeString =
        diffHours > 0
          ? `${diffHours}h ${remainingMinutes}m`
          : `${diffMinutes}m`;

      if (order.customer) {
        setCustomerName(order.customer.name);
      }
      setElapsedTime(timeString);
      setTableStatus(order.status);
      setOrderAmount(order.billTxnLogs?.total || order.amount);
      setIsOrderRunning(true);
    } else {
      setElapsedTime(0);
      setTableStatus("VACANT");
      setOrderAmount(0);
      setCustomerName("");
      setIsOrderRunning(false);
    }
    setUpdate((prev) => prev + 1);
  };
  useEffect(() => {
    fetchTableStatus();
  }, [store.runningVPA]);

  return (
    <div
      onClick={() =>
        handleTableSelect({
          table,
          room,
        })
      }
      key={table.tableNo + update}
      className={`w-[120px] min-h-24 cursor-pointer rounded-lg p-2 flex flex-col gap-2 justify-between relative
      ${tableStatus === "VACANT" && "bg-gray-300"}
      ${tableStatus === "bill-requested" && "bg-purple-400 text-white"}
      ${
        (tableStatus === "KOTPrint" || tableStatus == "in-process") &&
        "bg-green-500 text-white"
      }
      ${tableStatus === "KOTUpdated" && "bg-green-500 text-white"}
      ${tableStatus === "RequestKOT" && "bg-blue-500  text-white"}`}
    >
      <div className="flex justify-between items-center text-md font-bold">
        {room.roomName != "Parcel" ? (
          <span className="text-lg">T {table.tableNo}</span>
        ) : (
          <span className="text-lg">P {table.tableNo}</span>
        )}
        {tableStatus != "VACANT" && (
          <div className="flex items-center gap-1 text-sm">
            <img src={clockIcon} alt="Clock Icon" />
            {elapsedTime || "0m"}
          </div>
        )}
      </div>
      {isOrderRunning && (
        <div className="text-sm font-normal">
          <>
            <p className="font-bold">₹ {parseFloat(orderAmount).toFixed(2)} </p>
            <p>{customerName}</p>

            {room != "Parcel" && (
              <button className="absolute bottom-0 right-0 pl-1 pt-1 bg-white rounded-tl-lg rounded-none rounded-br-none rounded-bl-none flex items-center justify-center">
                <span className="bg-[#F3F9FF] p-2 rounded-md">
                  <img src={previewIcon} alt="Preview Icon" />
                </span>
              </button>
            )}
          </>
        </div>
      )}
    </div>
  );
};

const Switchtable = ({ show, close, updateOrder }) => {
  const { deleteOrder } = useOrder();
  const { rooms, tables, runningVPA } = store;
  const [loading, setLoading] = useState(false);
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [runningTables, setRunningTables] = useState([]);
  const [emptyTables, setEmptyTables] = useState([]);
  const [tablesMap, setTablesMap] = useState({});

  useEffect(() => {
    if (tables.length == 0) return;

    const occupiedTables = Object.keys(runningVPA);
    const runningTables = tables.filter((table) =>
      occupiedTables.includes(table.qrpidVPA)
    );
    const emptyTables = tables.filter(
      (table) => !occupiedTables.includes(table.qrpidVPA)
    );
    setEmptyTables(emptyTables);
    setRunningTables(runningTables);
    setTablesMap(
      tables.reduce((acc, table) => {
        acc[table.qrpidVPA] = table;
        return acc;
      }, {})
    );
  }, [tables, runningVPA]);

  const handleSwitch = async () => {
    try {
      setLoading(true);
      const order = runningVPA[fromValue];
      const typeOfOrder =
        tablesMap[toValue].room === "Parcel" ? "takeaway" : "dining";
      const payload = {
        orderId: order.orderID,
        updates: [
          {
            action: "updateTable",
            newTableVpa: toValue,
          },
          { action: "updateTypeOfOrder", type: typeOfOrder },
        ],
      };

      const { status, data } = await updateOrder(payload);
      if (status === SUCCESS) {
        await deleteOrder(fromValue);
        setFromValue("");
        setToValue("");
        toast.success("Table switched successfully");
        close();
      } else {
        toast.error("Something wemt wrong, please try again");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something wemt wrong, please try again");
    } finally {
      setLoading(false);
    }
  };
  if (!show) {
    return null;
  }
  return (
    <div className="fixed inset-0 bg-black/20 z-40" style={{ zIndex: "100" }}>
      <div className="absolute top-[50%] left-[50%] transform -translate-x-1/2  -translate-y-1/2 bg-white shadow-lg rounded-lg p-6 z-100">
        <h3 className="text-lg font-bold mb-6 text-gray-700">
          Switch to a different table
        </h3>

        <div className="flex flex-col sm:flex-row items-center gap-5">
          <div className="flex flex-col space-y-2">
            <label htmlFor="fromDropdown" className="text-lg font-medium">
              From:
            </label>
            <select
              id="fromDropdown"
              className="border border-gray-300 rounded-md p-2 w-64 focus:ring-2 focus:ring-blue-500"
              value={fromValue}
              onChange={(e) => setFromValue(e.target.value)}
            >
              <option value="" disabled>
                Select an option
              </option>
              {runningTables.map((table, index) => (
                <option key={index} value={table.qrpidVPA}>
                  {table.room} - Table {table.tableNo}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col space-y-2">
            <label htmlFor="toDropdown" className="text-lg font-medium">
              To:
            </label>
            <select
              id="toDropdown"
              className="border border-gray-300 rounded-md p-2 w-64 focus:ring-2 focus:ring-blue-500"
              value={toValue}
              onChange={(e) => setToValue(e.target.value)}
            >
              <option value="" disabled>
                Select an option
              </option>
              {emptyTables.map((table, index) => (
                <option key={index} value={table.qrpidVPA}>
                  {table.room} - Table {table.tableNo}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* Buttons Section */}
        <div className="flex justify-end mt-6 space-x-3">
          <button
            onClick={close}
            className="bg-gray-400 text-white py-2 px-4 rounded-md hover:bg-gray-500 transition duration-300 min-w-[100px]"
          >
            Cancel
          </button>
          <button
            disabled={loading}
            onClick={handleSwitch}
            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300 min-w-[100px]"
          >
            {loading ? <Loader /> : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

const TableOverview = () => {
  const { rooms } = store;
  const { getAllOrders } = useOrder();
  const { updateOrder, getMenu } = useCloud();
  const [showRunningKOT, setShowRunningKOT] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [activeTab, setActiveTab] = useState("DineIn");
  const [showTableSwitch, setShowTableSwitch] = useState(false);
  const [producst, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const processMenu = (menu) => {
    let { products, categories } = menu.reduce(
      (acc, category) => {
        if (category.status !== "active") {
          return acc;
        }
        if (category.menuItems.length == 0) {
          return acc;
        }

        acc.products.push(
          ...category.menuItems.filter(item => item.status ==='active').map((item) => {
            item.category = category.categoryName;
            item.categoryDetails = category;
            return item;
          })
        );
        if (
          !acc.categories.some(
            (_category) => _category.categoryId == category.categoryId
          )
        )
          acc.categories.push(category);
        return acc;
      },
      {
        products: [],
        categories: [],
      }
    );

    categories = categories.sort((a, b) => a.categoryRank - b.categoryRank);
    return { products, categories };
  };

  const fetchMenu = async () => {
    const menu = await getMenu();
    if (menu && menu.status === SUCCESS) {
      const { data } = menu;

      if (data.length <= 0) {
        return;
      }

      const { products, categories } = processMenu(data);
      const productDeatilsMap = products.reduce((acc, product) => {
        acc[product.id] = product;
        return acc;
      }, {});

      setProducts(products);
      setCategories(categories);
    }
  };

  useEffect(() => {
    store.setShowRunningKOT = setShowRunningKOT;
  }, []);

  useEffect(() => {
    const fetchAllOrders = async () => {
      const orders = await getAllOrders();
      store.runningVPA = orders.reduce((acc, order) => {
        acc[order.tableVPA] = order;
        return acc;
      }, {});
    };

    setTimeout(() => fetchAllOrders(), 100);
    window.addEventListener("ORDER_DONE", fetchAllOrders);
    window.addEventListener("KOTUpdated", fetchAllOrders);
    window.addEventListener("digitalOrderProcessed", fetchAllOrders);
    window.addEventListener("liveOrder", fetchAllOrders);

    return () => {
      window.removeEventListener("ORDER_DONE", fetchAllOrders);
      window.removeEventListener("KOTUpdated", fetchAllOrders);
      window.removeEventListener("digitalOrderProcessed", fetchAllOrders);
      window.removeEventListener("liveOrder", fetchAllOrders);
    };
  }, []);

  useEffect(() => {
    fetchMenu();
  }, []);
  const hanldeTableSelect = ({ table, room }) => {
    setSelectedTable({
      room: room.roomName,
      table: table.tableNo,
      tableVPA: table.qrpidVPA,
    });
  };

  const renderDineInView = () => {
    return (
      <>
        {selectedTable && (
          <OrderMenu
            data={{
              room: selectedTable.room,
              table: selectedTable.table,
              vpa: selectedTable.tableVPA,
              tableVPA: selectedTable.tableVPA,
            }}
            products={producst}
            categories={categories}
            closeEdit={() => setSelectedTable(null)}
          />
        )}

        <div className="p-4 bg-gray-50 overflow-x-hidden relative hide-scrollbar">
          {rooms
            .filter((room) => {
              if (activeTab === "DineIn" && room.roomName != "Parcel") {
                return true;
              } else if (activeTab === "Parcel" && room.roomName == "Parcel") {
                return true;
              } else {
                return false;
              }
            })
            .map((room) => (
              <div className="w-full mb-8" key={room?.roomName}>
                <div className="mb-1">
                  <div
                    className="p-1 border-[0.92px] border-[#16A34A] text-[#16A34A] font-semibold rounded text-center mb-2 inline-block"
                    style={{ minWidth: "150px" }}
                  >
                    {room?.roomName}
                  </div>
                  <div className="flex-1"></div>
                </div>
                <div className="flex flex-wrap gap-4">
                  {room?.tables &&
                    room?.tables.map((table) => (
                      <TableCard
                        key={table}
                        table={table}
                        room={room}
                        handleTableSelect={hanldeTableSelect}
                      />
                    ))}
                </div>
              </div>
            ))}
        </div>

        <Switchtable
          show={showTableSwitch}
          close={() => setShowTableSwitch(false)}
          updateOrder={updateOrder}
        />
        <button
          className="absolute top-[50px] right-5 pointer-cursor"
          onClick={() => setShowTableSwitch(true)}
        >
          <span className="flex flex-col gap-2 items-center justify-center">
            <img
              className="bg-green-100 p-3 shadow-lg rounded-full"
              src={transferIcon}
            />{" "}
            <span>Transfer</span>
          </span>
        </button>
      </>
    );
  };

  const renderOtherDeliveriesView = () => {
    return <PartnerOrders />;
  };

  return (
    <div className="bg-gray-50  h-screen relative">
      <RunningKOTStatus
        open={showRunningKOT}
        onClose={() => setShowRunningKOT(false)}
      />
      <TabNavigation
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setShowRunningKOT={setShowRunningKOT}
      />

      {["DineIn", "Parcel"].includes(activeTab) && renderDineInView()}
      {["Other"].includes(activeTab) && renderOtherDeliveriesView()}
    </div>
  );
};

export default observer(TableOverview);
